import { Injectable } from '@angular/core';
import { iBisEntityService } from '@dohu/ibis-entity';
import { iBisAuthService, iBisSecureEditService } from '@dohu/ibis-auth';
import { iBisLanguageService, iBisServerConfig } from '@dohu/ibis-common';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { GoogleMapsService } from '../../../service/google-maps.service';
import * as XLSX from 'xlsx';
import notify from 'devextreme/ui/notify';

@Injectable({
    providedIn: 'root'
})
export class UploadExcelService extends iBisSecureEditService {

    routes: any[] = [];
    fileInformation = new BehaviorSubject<{ name: string, numberOfLocations: number, date: any }>(null);
    coordonites = []

    constructor(auth: iBisAuthService, entity: iBisEntityService, config: iBisServerConfig, lg: iBisLanguageService,
        private googleService: GoogleMapsService) {
        super(auth, entity, config, lg);
        this.title = 'EXCEL';
    }

    protected load(): void {
    }

    public set routesData(data: any) {
        this.routes = data;
    }

    public get routesData(): any {
        return this.routes;
    }

    createDefault() {
        return {};
    }
    getById(id: string): Promise<any> {
        throw new Error('Method not implemented.');
    }
    onRemove(id: string): Promise<void> {
        throw new Error('Method not implemented.');
    }
    onSaveEv(serverUrl?: string): Promise<any> {
        throw new Error('Method not implemented.');
    }
    reset(): void {
        this.model = this.createDefault();
    }

    popupInit(ev: any) {
        super.popupInit(ev);
        ev.component.beginUpdate();
        const tbBtns = [{
            location: 'after',
            options: {
                text: 'Genereaza ruta',
                icon: 'route',
                type: 'default',
                onClick: (e: any) => {
                    if (this.fileInformation.getValue() === null) {
                        notify('Nu ai selectat un fisier', 'warning', 3000);
                        return;
                    }
                    this.googleService.calculateOptimalRoute(this.coordonites).then((result: any) => {
                        console.log(result, 'result')

                        // temporary
                        const currentRoute = {
                            id: this.routesData.length, link: result.link, name: this.fileInformation.getValue().name,
                            date: this.fileInformation.getValue().date, numberOfLocations: result.optimizedCoordinates.length, coordinates: result.optimizedCoordinates
                        };
                        this.routesData = [...this.routesData, currentRoute]
                        this.fileInformation.next(null);
                        this.hidePopup();
                    });
                }
            },
            toolbar: 'bottom',
            widget: 'dxButton'
        }];
        ev.component.option('toolbarItems', tbBtns);
        ev.component.endUpdate();
    }


    handleFile(file: File): void {
        this.coordonites = []
        console.log(file, 'file')
        const reader = new FileReader();
        reader.onload = (e: any) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            const sheetName = workbook.SheetNames[0];
            const sheet = workbook.Sheets[sheetName];
            const json = XLSX.utils.sheet_to_json(sheet);
            console.log("Excel Data:", json);
            json.forEach((row: any) => {
                const location = {
                    address: row['Adresa'],
                    //lat: row['Geo Y'],
                    // lng: row['Geo X'],

                    // reversed X and Y because of the way the data is structured
                    lat: row['Geo X'],
                    lng: row['Geo Y'],
                };
                this.coordonites.push(location);
            });
            //this.coordonites.length = 25;
            this.fileInformation.next({ name: file.name, numberOfLocations: this.coordonites.length, date: file.lastModified });

        };
        reader.readAsArrayBuffer(file);
    }

    isExcel(file: File): boolean {
        return file.name.endsWith('.xlsx') || file.name.endsWith('.xls');
    }

}
